import { _createEl } from '../../common/_create-el';
import './__button-close.scss';

const blockName = 'layout-search';

export function layoutSearchButtonClose() {
    return _createEl('div', `${blockName}__icon ${blockName}__icon_type_close`);
}
